import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";
import { userRoles } from "../../../../assets/constants";
import SelectArrow from "../../../../components/selectArrow";
import { useOutsideAlerter } from "../../../../hooks/utils";

const AddNewAdditionalInfo = ({ setAdditionalUser, addRole, allUsers }) => {
  const rolesRef = useRef(null);
  const usersRef = useRef(null);
  const [selectedRole, setSelectedRole] = useState(
    addRole.role ? addRole.role : "Artist"
  );
  const [showRolesOptions, setShowRoles] = useState(false);
  const [showUsersOptions, setShowUsersOptions] = useState(false);
  const [options, setOptions] = useState(allUsers);
  const [user, setUser] = useState({});
  const [username, setUserName] = useState(
    addRole.username ? addRole.username : "@"
  );
  useOutsideAlerter(rolesRef, setShowRoles);
  useOutsideAlerter(usersRef, setShowUsersOptions);

  useEffect(()=>{
    onChangeRole(selectedRole)
  }, [allUsers])

  const onChangeUserName = (e) => {
    const value = e.target.value;
    if (value?.substring(0, 1) === "@") {
      setUserName(value);
      const filter = allUsers.filter(
        (a) =>
          `@${a.username}`.toLowerCase().includes(value.toLowerCase()) &&
          a.accountType.includes(selectedRole)
      );
      setOptions(filter);
    }
  };

  useEffect(() => {
    if (username && selectedRole) {
      setAdditionalUser({ ...addRole, userId: user.id, role: selectedRole, username });
    }
  }, [username, selectedRole]);

  const onChangeRole = (role) => {
    setSelectedRole(role);
    setShowRoles(false);
    const filter = allUsers.filter(
      (a) =>
        `@${a.username}`.toLowerCase().includes(username.toLowerCase()) &&
        a.accountType.includes(role)
    );
    setOptions(filter);
  }

  return (
    <div className={styles.additionalInfosList}>
      <div className={styles.select} ref={rolesRef}>
        <div className={styles.selectedType} onClick={() => setShowRoles(true)}>
          <div className={styles.select}>{selectedRole}</div>
          <SelectArrow />
        </div>
        {showRolesOptions && (
          <div className={styles.options}>
            {userRoles.map((role) => (
              <div
                key={role}
                className={styles.option}
                onClick={() => onChangeRole(role)}
              >
                {role}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.searchUser} ref={usersRef}>
        <input
          value={username}
          onFocus={() => setShowUsersOptions(true)}
          onChange={(e) => onChangeUserName(e)}
        />
        {showUsersOptions && options.length > 0 && (
          <div className={styles.options}>
            {options.map((usr, index) => (
              <div
                key={index}
                className={styles.option}
                onClick={() => {
                  setUserName(`@${usr.username}`);
                  setShowUsersOptions(false);
                  setUser(usr);
                }}
              >
                {usr.username}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

AddNewAdditionalInfo.propTypes = {
  setAdditionalUser: PropTypes.func,
  addRole: PropTypes.object,
  allUsers: PropTypes.array,
};

export default AddNewAdditionalInfo;
